import ClientAgent from '../clientAgent'
import {instances} from 'chart.js'

export default class CloudUser {
  static instances = {}
  _id = null
  _ownUser = null
  _username = null
  _detailsLoaded = false
  _email = null
  _gsm = null
  _password = null
  _passwordConfirm = null
  _ca = null
  _siteId = null
  _ownerEmail = null

  static getInstance (id) {
    if (this.instances[id] === undefined) {
      this.instances[id] = new this(id)
    }
    return this.instances[id]
  }

  constructor (id = null) {
    this._id = id
  }

  /**
   * @param {number} id
   * @param {boolean} ownUser
   * @param {string} username
   * @param {number} siteId
   * @param {string} ownerEmail
   */
  loadBasicUserData (id, ownUser, username, siteId, ownerEmail, email, gsm) {
    this._id = id
    this._ownUser = ownUser
    this._username = username
    this._detailsLoaded = false
    this._siteId = siteId
    if (ownerEmail !== null) {
      this._ownerEmail = ownerEmail
    }
    if (email !== undefined && email !== null) {
      this._email = email
    }
    if (gsm !== undefined && gsm !== null) {
      this._gsm = gsm
    }
  }

  /**
   * @param {number} idTerminationPoint
   */
  async addNew (idTerminationPoint) {
    if (
      this._email !== null &&
      this._gsm !== null &&
      this._username !== null &&
      this._password !== null &&
      this.passwordConfirm !== null &&
      this.password === this.passwordConfirm &&
      !isNaN(idTerminationPoint)
    ) {
      let response = await this.ca.makeRequest('openStack/servisne/addCloudUserToProject', {
        email: this._email,
        gsm: this._gsm,
        username: this._username,
        password: this._password,
        idTerminationPoint: idTerminationPoint
      })
      if (response.cloudUser !== undefined) {
        this._id = response.cloudUser.id
        this._ownUser = response.cloudUser.ownUser
        this._username = 'cloud_' + this._username
        instances[this._id] = this
      }
    } else {
      throw new Error('Napaka vnosa podatkov')
    }
  }

  /**
   * @returns {Promise<any>}
   */
  sendPasswordResetPin () {
    if (this.id === null) {
      throw new Error('Ne najdem uporabnika')
    }
    return this.ca.makeRequest('openStack/servisne/sendPasswordResetPin', {id: this.id})
  }

  /**
   *
   * @param {string} newPassword
   * @param {string} pin
   * @returns {Promise<any>}
   */
  resetPassword (newPassword, pin) {
    if (this.id === null) {
      throw new Error('Ne najdem uporabnika')
    }
    return this.ca.makeRequest('openStack/servisne/resetPassword', {id: this.id, password: newPassword, pin: pin})
  }

  /**
   * @param {string} oldPassword
   * @param {string} newPassword
   * @returns {Promise<any>}
   */
  changePassword (oldPassword, newPassword) {
    if (this.id === null) {
      throw new Error('Ne najdem uporabnika')
    }
    return this.ca.makeRequest('openStack/servisne/changePassword', {
      id: this.id,
      newPassword: newPassword,
      oldPassword: oldPassword
    })
  }

  changeData (data) {
    if (this.id === null) {
      throw new Error('Ne najdem uporabnika')
    }
    return this.ca.makeRequest('openStack/servisne/changeUserData', {
      id: this.id,
      ...data
    })
  }

  get id () {
    return this._id
  }

  set id (value) {
    this._id = value
  }

  get ownUser () {
    return this._ownUser
  }

  set ownUser (value) {
    this._ownUser = value
  }

  get username () {
    return this._username
  }

  set username (value) {
    this._username = value
  }

  get detailsLoaded () {
    return this._detailsLoaded
  }

  set detailsLoaded (value) {
    this._detailsLoaded = value
  }

  get email () {
    return this._email
  }

  set email (value) {
    this._email = value
  }

  get gsm () {
    return this._gsm
  }

  set gsm (value) {
    this._gsm = value
  }

  get password () {
    return this._password
  }

  set password (value) {
    this._password = value
  }

  get passwordConfirm () {
    return this._passwordConfirm
  }

  set passwordConfirm (value) {
    this._passwordConfirm = value
  }

  /**
   * @returns {null | ClientAgent}
   */
  get ca () {
    if (this._ca === null) {
      this._ca = new ClientAgent()
    }
    return this._ca
  }

  set ca (value) {
    this._ca = value
  }

  get siteId () {
    return this._siteId
  }

  set siteId (value) {
    this._siteId = value
  }

  get ownerEmail () {
    return this._ownerEmail
  }

  set ownerEmail (value) {
    this._ownerEmail = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/T2Cloud/CloudUser.js